module.exports = __webpack_public_path__ + "static/media/Bookstore.c625aa4d.png";